export const appleSSO = {
  ContinueWithApple: "Continue with Apple",
  Or: "Or",
} as const;
